import ErrorPageContainer from './ErrorPageContainer';

const ErrorPage503 = () => {
  return (
    <ErrorPageContainer
      errorPageCode='/static/images/error/503.png'
      errorTextFirstLine='Sunucu geçici bir hatayla karşılaştı ve isteğinizi'
      errorTextSecondLine='tamamlayamadı. Lütfen tekrar deneyin.'
    />
  );
};
export default ErrorPage503;
